import {inject} from '@angular/core';
import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {tap} from 'rxjs/operators';
import {Store} from "@ngxs/store";
import {Logout} from 'src/app/shared/state/session-state.actions';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

/**
 * If any ajax call results in a 401, destroy our token and go to login.
 */
export const logoutOnUnauthInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(Store);
  const modalService = inject(NgbModal);

  return next(req)
    .pipe(
      tap({
        error: err => {
          if (err instanceof HttpErrorResponse) {
            if (err.status == 401 || (err.status == 400 && err.error?.error === 'token_not_provided')) {
              // Close any open modals and logout
              modalService.dismissAll();

              // See if we had a login token before.  If we did, we can change the messaging.
              // const hadToken = !!store.selectSnapshot(SessionState.token);
              // this.authService.logout(hadToken);
              store.dispatch(Logout);
            }
          }
        }
      })
    );
};
